import { clsx } from 'clsx';
import React from 'react';

import * as styles from './SaleTiles.css';

// SaleEventTileWrapper component
interface SaleEventTileWrapperProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export const SaleEventTileWrapper: React.FC<SaleEventTileWrapperProps> = ({
  children,
  className,
  onClick,
  style,
}) => (
  <div
    className={clsx(styles.saleEventTileWrapper, className)}
    onClick={onClick}
    style={style}
  >
    {children}
  </div>
);

// SaleTilesContainer component
export const SaleTilesContainer: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <div className={clsx(styles.saleTilesContainer, className)}>{children}</div>
);

// Status component
export const Status: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <span className={clsx(className)}>{children}</span>
);

// Price component
export const Price: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <span className={clsx(className)}>{children}</span>
);

// UnHideIconContainer component
export const UnHideIconContainer: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <span className={clsx(styles.unHideIconContainer, className)}>
    {children}
  </span>
);

// Divider component
export const Divider: React.FC<{ className?: string }> = ({ className }) => (
  <div className={clsx(styles.divider, className)} />
);

// DetailLabel component that handles textAlign prop
interface DetailLabelProps {
  textAlign?: 'left' | 'center' | 'right';
  children: React.ReactNode;
  className?: string;
}

export const DetailLabel: React.FC<DetailLabelProps> = ({
  textAlign = 'left',
  children,
  className,
}) => (
  <span
    className={clsx(
      styles.detailLabel,
      styles.detailLabelTextAlign[textAlign],
      className
    )}
  >
    {children}
  </span>
);

// DetailValue component that handles textAlign prop
interface DetailValueProps {
  textAlign?: 'left' | 'center' | 'right';
  children: React.ReactNode;
  className?: string;
}

export const DetailValue: React.FC<DetailValueProps> = ({
  textAlign = 'left',
  children,
  className,
}) => (
  <span
    className={clsx(
      styles.detailValue,
      styles.detailValueTextAlign[textAlign],
      className
    )}
  >
    {children}
  </span>
);

// DetailUnitCostValue component
export const DetailUnitCostValue: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <span className={clsx(styles.detailUnitCostValue, className)}>
    {children}
  </span>
);

// OtherDetailsDiv component
export const OtherDetailsDiv: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <div className={clsx(styles.otherDetailsDiv, className)}>{children}</div>
);
